module.exports = __webpack_public_path__ + "static/media/yeti.f0e27d8e.jpg";